import { Immutable } from "immer";
import React, { useRef, useState } from "react";
import { t } from "ttag";

import { Modal } from "../../../components/Modal";
import { focusElement } from "../../../utils/keyboardFocus";
import { RootProductCompareModalContent } from "../RootProductCompareModalContent";
import { IModularConfiguratorOptionSet } from "../models";

import styles from "./index.module.scss";

type IProps = Immutable<{
    optionSet: IModularConfiguratorOptionSet;
}>;

export const RootProductCompareModal = (props: IProps): React.ReactNode => {
    const [isOpen, setIsOpen] = useState(false);
    const openButtonRef = useRef<HTMLButtonElement>(null);

    const onOpen = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        setIsOpen(true);
    };

    const onRequestClose = (): void => {
        setIsOpen(false);
    };

    const onAfterClose = (): void => {
        if (openButtonRef.current) {
            focusElement(openButtonRef.current);
        }
    };

    if (!props.optionSet.root_product_compare_modal) {
        return null;
    }

    return (
        <>
            <button
                ref={openButtonRef}
                className={styles.openBtn}
                onClick={onOpen}
            >
                {t`Compare`}
            </button>
            <Modal
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                onAfterClose={onAfterClose}
                className={styles.modalContent}
                aria={{
                    // TODO(i18n): This ID reference "heading" should correspond to a translatable heading element
                    labelledby: "heading",
                }}
            >
                <RootProductCompareModalContent optionSet={props.optionSet} />
            </Modal>
        </>
    );
};
